import { render, staticRenderFns } from "./AddPropertyForSale.vue?vue&type=template&id=224a9446&"
import script from "./AddPropertyForSale.vue?vue&type=script&lang=js&"
export * from "./AddPropertyForSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports